import { CHARACTER_MODERATION_STATUS } from "./sharedTypes";
/**
 * A chatbot can't have a lorebook attached while it is in moderation: either awaiting review
 * (pending / rereview_required / manual_review_required, or the AICQ manual-review flag) or
 * waiting on creator changes (fix_required).
 *
 * Chatbots carry their moderation state in three fields, and a bot can be blocked by any of them:
 *   - `moderationReportStatus` — flat status (web's my-chatbots list)
 *   - `moderationReport.moderation_status` — nested status (native's getAllCharacters)
 *   - `aicq_manual_review_required` — an independent flag that the card components already treat as
 *     taking precedence over the status, and that Chat redirects away from entirely
 * The two status enums share the same string values, so read whichever is present. `fix_required`
 * still wins over the flag: "make changes" is the more actionable message when both apply.
 */
const getCharacterAttachBlockedStatus = (character) => {
    const status = character?.moderationReportStatus ?? character?.moderationReport?.moderation_status;
    if (status === CHARACTER_MODERATION_STATUS.FIX_REQUIRED)
        return "actionRequired";
    if (character?.aicq_manual_review_required === true ||
        status === CHARACTER_MODERATION_STATUS.PENDING ||
        status === CHARACTER_MODERATION_STATUS.REREVIEW_REQUIRED ||
        status === CHARACTER_MODERATION_STATUS.MANUAL_REVIEW_REQUIRED) {
        return "underReview";
    }
    return "none";
};
export default getCharacterAttachBlockedStatus;
